var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "c-restrictiveComponent" }, [
    _c("div", { staticClass: "c-restrictiveComponent_wrapDescription" }, [
      _c(
        "svg",
        {
          class: "c-restrictiveComponent_icon",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            "svg-inline": "",
            role: "presentation",
            focusable: "false",
            tabindex: "-1",
          },
        },
        [
          _c("path", {
            attrs: {
              "data-name": "Caminho 4213",
              d: "M0 30A30 30 0 1030 0 30 30 0 000 30z",
              fill: "#f6f6f6",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4214",
              d: "M17.514 50.635c0 .862 5.59 1.561 12.486 1.561s12.486-.7 12.486-1.561-5.59-1.561-12.486-1.561-12.486.7-12.486 1.561z",
              fill: "#ffdc91",
              stroke: "#3d3d3d",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4215",
              d: "M16.212 24.205h27.577v25.058H16.212z",
              fill: "#fff",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4216",
              d: "M16.212 24.205h27.577v25.058H16.212z",
              fill: "none",
              stroke: "#3d3d3d",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4217",
              d: "M32.378 37.101a2.377 2.377 0 10-3.8 1.891v2.85a1.425 1.425 0 102.85 0v-2.85a2.368 2.368 0 00.95-1.891z",
              fill: "#ffdc91",
              stroke: "#3d3d3d",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4218",
              d: "M40.936 16.125a10.936 10.936 0 10-21.872 0v8.08h4.752v-8.08a6.181 6.181 0 0112.362 0v8.08h4.758z",
              fill: "#ffdc91",
            },
          }),
          _c("path", {
            attrs: {
              "data-name": "Caminho 4219",
              d: "M40.936 16.125a10.936 10.936 0 10-21.872 0v8.08h4.752v-8.08a6.181 6.181 0 0112.362 0v8.08h4.758z",
              fill: "none",
              stroke: "#3d3d3d",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-restrictiveComponent_description" }, [
        _vm._v("\n      Libere "),
        _c("strong", [_vm._v(_vm._s(_vm.text))]),
        _vm._v(
          " assinando um plano CoteiBem para " +
            _vm._s(_vm.companyName) +
            "!\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "c-restrictiveComponent_button",
        attrs: { href: _vm.planUpgrade.index },
      },
      [_vm._v("Ver benefícios")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }